import { request } from 'axios';
import CustomError from 'error.js';
import config from 'Config';
export const PertimmRequestFailed = CustomError.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed',
});

const getAxiosConfig = function getAxiosConfig() {
  const proxyConfig = config.get('pertimm.proxy');
  let httpsAgent;

  if (typeof window === 'undefined') {
    if (proxyConfig) {
      httpsAgent = require('tunnel').httpsOverHttp({
        proxy: proxyConfig,
      });
    }
  }

  return {
    httpsAgent,
    proxy: httpsAgent ? false : undefined,
  };
};

const START_INDEX_PARAM = 'res_sf';

function recursivePostRequest({ axiosConfig, url, payload, queryparams, acc }) {
  return request({ ...axiosConfig, method: 'POST', url, data: payload, params: queryparams })
    .then(({ data } = {}) => {
      if (!acc) {
        acc = { ...data };
      } else {
        acc.answers = [...acc.answers, ...(data.answers || [])];
      }

      const nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
      const hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
      return hasMoreAnswers
        ? recursivePostRequest({
            axiosConfig,
            url,
            payload,
            queryparams: { ...queryparams, [START_INDEX_PARAM]: nextStart },
            acc,
          })
        : acc;
    })
    .catch((error = {}) => {
      const { response: { status = 500, data = '' } = {} } = error;
      throw new PertimmRequestFailed({
        statusCode: status,
        errors: data,
      });
    });
}

type RequestParams = {
  locale: AppContext['locale'];
  payload?: string;
  queryparams?: Record<string, any>;
};
export function postSearchRequest({ locale, payload = '', queryparams = {} }: RequestParams) {
  return recursivePostRequest({
    url: config.get('pertimm.apiUrl'),
    axiosConfig: getAxiosConfig(),
    payload,
    queryparams: {
      enable_interpretation_explanation: true,
      [START_INDEX_PARAM]: 0,
      search_locale: locale,
      user_locale: locale,
      ...queryparams,
    },
    acc: undefined,
  });
}
